import axios from 'axios';
import store from '../store/index';
import router from '../router/index';

// https://lvyou.ysxcs.cn
const instance = axios.create({
      baseURL:'https://interface.2855855.com/front/',
      headers: {
        'Content-Type': "application/json"
      }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    config.headers.token = store.getters.token || '-1';
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


instance.interceptors.response.use(
  response => {
    // console.log(response)
    const data = response.data;
 let {
  code,
  msg
 } = data

 /* if (code == 2033) {  // 没有设置支付密码
  alert('请设置支付密码')
 } */
    return response.data;
  },
  error => {
    if (error.response) {
      console.log('请求发出后，服务器使用状态码进行响应，该状态码超出了2xx的范围');
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      console.log('请求已发出，但没有收到响应错误。');
      console.log(error.request);
    } else {
      console.log('在设置请求时发生了一些事情，触发了一个错误');
      console.log('Error', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance;



// WEBPACK FOOTER //
// ./src/utils/http.js